import React from "react";
import { Box, Shield, Clock, MapPin, IndianRupee, Users } from "lucide-react";
import { WHY_CHOOSE_US, STATS } from "../data/mock";

const ICON_MAP = {
  Cube: Box,
  Shield,
  Clock,
  MapPin,
  IndianRupee,
  Users,
};

export function WhyChooseUs({ onGetQuote }) {
  return (
    <section id="services" className="py-20 bg-white" data-testid="why-choose-us">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#C9A84C] text-sm font-semibold tracking-widest uppercase">Why Us</span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-[#1a1a1a] mt-2 mb-3">
            Why Hyderabad Families Choose Us
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            We combine creative design, quality materials, and professional execution to deliver interiors that exceed expectations
          </p>
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-16">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="text-center bg-[#1a1a1a] text-white rounded-xl p-6"
            >
              <div className="font-serif text-3xl sm:text-4xl font-bold text-[#C9A84C] mb-1">{stat.number}</div>
              <div className="text-sm text-gray-300">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_CHOOSE_US.map((item) => {
            const Icon = ICON_MAP[item.icon] || Box;
            return (
              <div
                key={item.title}
                className="group p-7 rounded-xl border border-gray-100 hover:border-[#C9A84C]/30 hover:shadow-lg transition-all duration-300"
                data-testid={`feature-${item.icon.toLowerCase()}`}
              >
                <div className="w-12 h-12 bg-[#C9A84C]/10 rounded-xl flex items-center justify-center mb-5 group-hover:bg-[#C9A84C] transition-colors">
                  <Icon size={22} className="text-[#C9A84C] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-serif text-lg font-bold text-[#1a1a1a] mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={onGetQuote}
            className="bg-[#C9A84C] text-white font-bold px-10 py-4 rounded-full hover:bg-[#b8933e] transition-colors"
            data-testid="why-us-quote-btn"
          >
            Get Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
